/* Saber Legacy — reglas de meses sin intereses en la tienda (14 oct 2026).
   Shopify Payments ofrece: 3 y 6 MSI desde $3,000 · 9 MSI desde $4,000 · 12 MSI desde $7,500
   (decisión de Juan, 14 oct). Este archivo hace que lo que se anuncia coincida con eso:
   - Ficha (saber-buybox): la caja escribe "12 meses sin intereses de $X" con cualquier precio.
     Aquí se cambia al plazo más largo que de verdad aplica a ese precio y se avisa que los 12
     llegan desde $7,500. Se vuelve a aplicar cada vez que el cliente cambia de opción.
   - Pie de página ("12 MSI DISPONIBLES") y renglón de confianza del carrito ("12 MSI").
   Si cambian los mínimos en Shopify, basta con cambiar PLANES aquí. */
(function () {
  var PLANES = [[750000, 12], [400000, 9], [300000, 6]]; // [mínimo en centavos, meses]
  var AVISO_12 = 'Con tarjetas participantes · 12 MSI desde $7,500';
  var AVISO_BASE = 'Con tarjetas participantes · sin enganche';

  function dinero(c) {
    return '$' + (c / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  /* Solo escribe si cambia: escribir lo mismo dispararía otra vez al observador. */
  function poner(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
  function plazo(c) {
    for (var i = 0; i < PLANES.length; i++) if (c >= PLANES[i][0]) return PLANES[i][1];
    return 0;
  }

  /* Ficha: data-sl-msi (texto largo) y data-sl-msishort (barra fija). */
  function ficha() {
    var els = document.querySelectorAll('[data-sl-msi],[data-sl-msishort]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var largo = el.hasAttribute('data-sl-msi');
      var m = (el.textContent || '').match(/^12 (?:meses sin intereses|MSI) de \$([\d,]+(?:\.\d+)?)/);
      if (!m) continue;
      var precio = Math.round(parseFloat(m[1].replace(/,/g, '')) * 1200);
      var n = plazo(precio);
      var aviso = largo && el.parentNode ? el.parentNode.querySelector('span') : null;
      if (n === 12) { poner(aviso, AVISO_BASE); continue; }
      if (n === 0) poner(el, largo ? 'Meses sin intereses desde $3,000' : 'MSI desde $3,000');
      else poner(el, n + (largo ? ' meses sin intereses de ' : ' MSI de ') + dinero(precio / n));
      poner(aviso, AVISO_12);
    }
  }

  /* Pie de página y carrito: textos fijos del tema. */
  function fijos() {
    /* Franja del pie: <span><i></i>12 MSI DISPONIBLES</span>. Se cambia solo el texto
       para no borrar el ícono. */
    var pie = document.querySelectorAll('.slfooter__trust-grid span');
    for (var i = 0; i < pie.length; i++) {
      var nodos = pie[i].childNodes;
      for (var j = 0; j < nodos.length; j++) {
        var nd = nodos[j];
        if (nd.nodeType === 3 && nd.nodeValue.trim() === '12 MSI DISPONIBLES') nd.nodeValue = 'HASTA 12 MSI';
      }
    }
    /* Carrito: <b>12 MSI</b><small>Tarjetas participantes</small>. */
    var cart = document.querySelectorAll('.slcart-v2__trust b');
    for (var k = 0; k < cart.length; k++) {
      if ((cart[k].textContent || '').trim() === '12 MSI') {
        poner(cart[k], 'HASTA 12 MSI');
        poner(cart[k].nextElementSibling, '12 MSI desde $7,500');
      }
    }
  }

  function todo() { ficha(); fijos(); }

  function iniciar() {
    todo();
    /* La ficha reescribe sus textos al cambiar de opción y el carrito se vuelve a pintar
       sin recargar: se observa la página y se corrige lo que regrese a "12". */
    if (window.MutationObserver) {
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        setTimeout(function () { pendiente = false; todo(); }, 30);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
